import gate from '@/api/axios';

/**
 * Получает список заказчиков
 * @async
 * @function customersSearch
 * @param {Object} payload
 * @returns {Promise}
 */
export const customersSearch = async (payload) => gate.get('/customers/search', {
  params: payload,
});

/**
 * Получает список заказчиков для бесконечного скролла
 * @async
 * @function customersSimpleSearch
 * @param {Object} payload Объект параметров
 * @returns {Promise}
 */
export const customersSimpleSearch = async (payload) => gate.get('/customers/simpleSearch', {
  params: payload,
});

/**
 * Получает профиль заказчика
 * @async
 * @function customerProfile
 * @param {Number|String} id ID заказчика
 * @returns {Promise}
 */
export const customerProfile = async (id) => gate.get(`/customers/${id}`);

/**
 * Получает список заказов заказчика
 * @param {Number|String} id ID заказчика
 * @returns {Promise}
 */
export const customerOrders = async (id, payload) => gate.get(`/customers/${id}/searchOrders`, {
  params: payload,
});

/**
 * Получает список объектов заказчика
 * @param {Number|String} id ID заказчика
 * @returns {Promise}
 */
export const customerObjects = async (id, payload) => gate.get(`/customers/${id}/searchSubjects`, {
  params: payload,
});

/**
 * Блокировка и разблокировка заказчика
 * @async
 * @function setCustomerBlocking
 * @param {Number|String} id ID заказчика
 * @param {Number|String} reason Причина блокировки
 * @returns {Promise}
 */
export const setCustomerBlocking = async (id, reason) => gate.post(`/customers/${id}/blocking`, {
  reason,
});

/**
 * Удаление заказчика
 * @async
 * @function customerDelete
 * @param {Number|String} id ID заказчика
 * @returns {Promise}
 */
export const customerDelete = async (id) => gate.delete(`/customers/${id}`);


/**
 * Получает шаблоны и историю Green API сообщений заказчика
 * @async
 * @function customerGreenApiMessages
 * @param {Number|String} id ID заказчика
 * @returns {Promise}
 */
export const customerGreenApiMessages = async (id) => gate.get(`/customers/${id}/green-api/messages`);

/**
 * Отправляет Green API сообщение заказчику по выбранному шаблону
 * @async
 * @function sendCustomerGreenApiMessage
 * @param {Number|String} id ID заказчика
 * @param {String} templateKey Ключ шаблона сообщения
 * @returns {Promise}
 */
export const sendCustomerGreenApiMessage = async (id, templateKey) => gate.post(`/customers/${id}/green-api/messages`, {
  templateKey,
});


/**
 * Получает историю произвольных PUSH заказчика
 * @async
 * @function customerPushMessages
 * @param {Number|String} id ID заказчика
 * @returns {Promise}
 */
export const customerPushMessages = async (id) => gate.get(`/customers/${id}/push/messages`);

/**
 * Отправляет произвольный PUSH заказчику
 * @async
 * @function sendCustomerPushMessage
 * @param {Number|String} id ID заказчика
 * @param {Object} payload Тело push-уведомления
 * @returns {Promise}
 */
export const sendCustomerPushMessage = async (id, payload) => gate.post(`/customers/${id}/push/messages`, payload);

/**
 * Единый центр коммуникаций заказчика: доступные каналы + общая история.
 * @param {Number|String} id ID пользователя-заказчика
 * @returns {Promise}
 */
export const customerCommunications = async (id) => gate.get(`/customers/${id}/communications`);

/**
 * Ручная отправка сообщения заказчику через выбранный канал.
 * @param {Number|String} id ID пользователя-заказчика
 * @param {Object} payload { channel, ...channelPayload }
 * @returns {Promise}
 */
export const sendCustomerCommunication = async (id, payload) => gate.post(`/customers/${id}/communications`, payload);

export const uploadCustomerCommunicationImages = async (id, payload) => gate.post(
  `/customers/${id}/communications/upload`,
  payload,
);

export const importCustomerTalkMe = async (id, dryRun = false) => gate.post(`/customers/${id}/support/import-talk-me`, { dryRun });

export const customerSupportUpload = async (id, payload) => gate.post(`/customers/${id}/support/upload`, payload);
export const customerSupportRead = async (id, messageIds = [], externalContactIds = []) => gate.post(`/customers/${id}/support/messages/read`, { messageIds, externalContactIds });
